import React, { useState } from 'react';
import OAuth2Login from './OAuth2Login';
import ErrorAlert from './ErrorAlert';
import {
  authorizationUrl,
  clientId,
  redirectUri,
  scope,
} from './settings-sample';

function widgetElement(accessToken) {
  console.log(accessToken);
  let widget = document.createElement("script");
  widget.type = "text/javascript";
  widget.charset = "utf-8";
  widget.innerHTML = "(function (g, e, n, es, ys) {g['_genesysJs'] = e;g[e] = g[e] || function () {(g[e].q = g[e].q || []).push(arguments)};g[e].t = 1 * new Date();g[e].c = es;ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);})(window, 'Genesys', 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js', {environment: 'euc1',deploymentId: '102fe28f-7295-4452-868d-d076813fedb0'});Genesys('registerPlugin', 'AuthProvider', (AuthProvider) => {AuthProvider.registerCommand('getAuthCode', (e) => {e.resolve({authCode: \""+accessToken+"\",redirectUri: \"https://webmessaginopenidudj.d6hmfbxfwj1pn.amplifyapp.com/\",});});AuthProvider.registerCommand('reAuthenticate', (e) => {e.resolve();});AuthProvider.subscribe('Auth.loggedOut', () => {console.log(\"Genesys logout\");});AuthProvider.subscribe('Auth.authError', (error) => {console.error(\"Genesys Auth Error: \", error);});AuthProvider.subscribe('Auth.error', (error) => {console.error(\"Genesys Auth Error: \", error);});AuthProvider.ready();});"

  document.body.appendChild(widget);
  return true;
}

export default function ImplicitGrantExample() {
  const [accessToken, setAccessToken] = useState(null);
  const [error, setError] = useState(null);


  const onSuccess = ({ access_token: token }) => setAccessToken(token);
  return (
    <div className="column">
      {
        error && <ErrorAlert error={error} />
      }
      <OAuth2Login
        authorizationUrl={authorizationUrl}
        clientId={clientId}
        redirectUri={redirectUri}
        scope={scope}
        responseType="id_token"
        buttonText="Implicit grant login"
        onSuccess={onSuccess}
        onFailure={setError}
      />
      {
        accessToken && <p>Access token: {accessToken}</p>
      }
      {
        accessToken && widgetElement(accessToken)
      }
    </div>
  );
}
